class CutCalculator extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.dom = {
            shapeInputs: this.querySelectorAll('input.cut-calculator__shape-input'),
            inputFields: this.querySelectorAll('input.cut-calculator__input-field'),
            formInputs: this.querySelectorAll(`[form="${ this.dataset.formId }"]`),

            price: document.querySelector(`.product-info__price .price__current`),
            compareAtPrice: document.querySelector(`.product-info__price .price__was`),
        }

        console.dir(this.dom.formInputs, { depth: null });

        this.settings = {
            basePrice: Number(this.dataset.price),
            baseCompareAtPrice: Number(this.dataset.compareAtPrice),
            currentShape: Array.from(this.dom.shapeInputs).find((input) => input.checked)?.value,
            width: Number(this.dataset.width),
        }

        console.dir(this.settings, { depth: null });


        if (this.dom.formInputs.length === 0) {
            console.warn('No shape inputs found in cut-calculator');
            return;
        }

        if (this.dom.inputFields.length === 0) {
            console.warn('No input fields found in cut-calculator');
            return;
        }
        if (this.dom.shapeInputs.length === 0) {
            console.warn('No shape inputs found in cut-calculator');
            return;
        }

        this.addEventListeners();


        this.handleShapeInputChange();
        this.updatePrice();
    }


    addEventListeners() {
        this.dom.formInputs.forEach((input) => {
            input.addEventListener('change', (event) => {
                this.inputFieldChange(event);
            })

            input.addEventListener('input', (event) => {
                this.inputFieldChange(event);
            })
        })
    }

    inputFieldChange = (event) => {
        if (event.target.classList.contains('cut-calculator__shape-input')) {
            this.settings.currentShape = event.target.value;
        }

        this.handleShapeInputChange();
        this.updatePrice();

        this.setPseudoInput(event.target);
    }

    handleShapeInputChange = () => {
        this.dom.inputFields.forEach((input) => {



            if (this.isElementHidden(input)) {
                input.disabled = true;
            } else {
                input.disabled = false;
            }

            // if the element has a data-pseudo-property-id attribute, set the disabled property on the pseudo input
            if (input.hasAttribute('data-pseudo-property-id')) {
                const pseudoInput = this.querySelector(`input#${ input.dataset.pseudoPropertyId }`);

                if (pseudoInput) {
                    pseudoInput.disabled = input.disabled;
                }

                // If input, that has a data-pseudo-property-id attribute, is also a checkbox, set the checked property on the pseudo input as disabled or not
                if (input.type === 'checkbox' && !input.disabled) {
                    if (pseudoInput) {
                        pseudoInput.disabled = !input.checked;
                    }

                    if (input.id === 'checkbox-buy-whole-roll') {
                        const lengthInput = this.querySelector('input#length');
                        const lenghtPseudoInput = this.querySelector(`input#propertyLength`);
                        if (lengthInput) {
                            lengthInput.disabled = input.checked;
                            lenghtPseudoInput.disabled = input.checked;
                        }
                    }
                }
            }
        })

    }

    isElementHidden = (element) => {
        let currentElement = element;
        while (currentElement) {
            const style = window.getComputedStyle(currentElement);
            if (style.display === 'none') {
                return true;
            }
            currentElement = currentElement.parentElement;
        }
        return false;
    }

    setPseudoInput = (input) => {
        const pseudoInput = this.querySelector(`input#${ input.dataset.pseudoPropertyId }`);
        const pseudoInputName = input.dataset.pseudoPropertyName;
        const pseudoInputUnit = input.dataset.pseudoPropertyUnit;
        let pseudoInputValue = null;

        if (input.hasAttribute('data-pseudo-property-value')) {
            const attributeValue = input.getAttribute('data-pseudo-property-value');
            pseudoInputValue = attributeValue ? attributeValue : input.value;
        }

        if (!pseudoInput) {
            return;
        }
        if (pseudoInputName) {
            pseudoInput.setAttribute('name', `properties[${ pseudoInputName }]`);
        }

        if (pseudoInputValue) {
            const valueWithUnit = pseudoInputUnit ? `${ pseudoInputValue } ${ pseudoInputUnit }` : pseudoInputValue;
            pseudoInput.setAttribute('value', valueWithUnit);
        }
    }

    updatePrice = () => {
        const pricePerCentimeter = this.settings.basePrice / 100;
        const compareAtPricePerCentimeter = this.settings.baseCompareAtPrice / 100;

        let price = this.settings.basePrice;
        let compareAtPrice = this.settings.baseCompareAtPrice;

        switch (this.settings.currentShape) {
            case 'Rectangular':
            case 'Oval':
                const lengthInput = this.querySelector('input#length');
                const lengthPseudoInput = this.querySelector(`input#propertyLength`);
                const widthInput = this.querySelector('input#width')
                const wholeRoll = this.querySelector('input#checkbox-buy-whole-roll');

                if (lengthInput && lengthInput.value) {
                    let length = Number(lengthInput.value);


                    if (wholeRoll && wholeRoll.checked && !wholeRoll.disabled) {
                        length = lengthInput.max;
                        lengthInput.disabled = true;
                        lengthPseudoInput.disabled = true;
                    } else {
                        lengthInput.disabled = false;
                        lengthPseudoInput.disabled = false;
                    }


                    price = pricePerCentimeter * length;
                    compareAtPrice = compareAtPricePerCentimeter * length;

                }

                if (wholeRoll && wholeRoll.checked && !wholeRoll.disabled) {
                    length = lengthInput.max;
                    price = pricePerCentimeter * length;
                    compareAtPrice = compareAtPricePerCentimeter * length;

                    price = price * .85;
                    compareAtPrice = compareAtPrice * .85;
                }

                if (widthInput && widthInput.value && widthInput.disabled === false) {
                    const widthPrice = Number(widthInput.dataset.cutDownPrice, 10) || 69;
                    price += widthPrice;
                    compareAtPrice += widthPrice;
                }

                if (this.settings.currentShape === 'Oval') {
                    price += this.settings.basePrice;
                    compareAtPrice += this.settings.basePrice;
                }

                break;

            case 'Round':
                const diameterInput = this.querySelector('input#diameter');
                const roundDiameterInMeters = Number(diameterInput.value / 100) || 0;
                this.setMaxDiameter(diameterInput, this.settings.width - 2);

                price = (this.settings.basePrice * roundDiameterInMeters) + this.settings.basePrice;
                compareAtPrice = (this.settings.baseCompareAtPrice * roundDiameterInMeters) + this.settings.baseCompareAtPrice;
                break;

            case 'Round with Elastic':
                const diameterWithElasticInput = this.querySelector('input#diameterWithElastic');
                const elasticDiameter = Number(diameterWithElasticInput.value) || 0;
                const thickness = Number(this.querySelector('input#thickness').value) || 0;
                const maxDiameter = this.settings.width - (6 + (2 * thickness));
                const elasticMultiplier = Number(diameterWithElasticInput.dataset.elasticMultiplier) || 1;
                this.setMaxDiameter(diameterWithElasticInput, maxDiameter);
                const roundDiameterWithElasticPriceCalculation = (price, diameter, thickness) => { 

                    if (thickness == 0) {
                        const diameterInMeters = diameter / 100;
                        return (price * diameterInMeters) + price;
                    }

                    return ((0.034012 * Math.pow(diameter + (2 * (thickness - 2)), 2)) - (4.313974 * (diameter + (2 * (thickness - 2)))) + 279.994475 + (1.064613 * price)) * elasticMultiplier;
                }


                price = roundDiameterWithElasticPriceCalculation(this.settings.basePrice, elasticDiameter, thickness);
                compareAtPrice = roundDiameterWithElasticPriceCalculation(this.settings.baseCompareAtPrice, elasticDiameter, thickness);

                break;
        }


        if (this.dom.price) {
            this.dom.price.innerHTML = this.formatPrice(price.toFixed(2), this.settings.currentShape === 'Round with Elastic');
        }

        if (this.dom.compareAtPrice && this.dom.compareAtPrice.innerHTML !== '') {

            if (compareAtPrice > 0) {

                this.dom.compareAtPrice.innerHTML = this.formatPrice(compareAtPrice.toFixed(2), this.settings.currentShape === 'Round with Elastic');
            } else {
                this.dom.compareAtPrice.innerHTML = '';
            }
        }
    }

    setMaxDiameter = (input, maxDiameter) => {
        if (input && maxDiameter) {
            input.setAttribute('max', maxDiameter);

        }
    }

    formatPrice = (price, roundPrice = false) => {

        const newPrice = roundPrice ? Math.round(price).toFixed(2) : price;

        // convert number to price with currency
        const currency = Shopify?.currency?.active || 'USD';


        // Format price based on currency/locale
        let formattedPrice = newPrice;

        // Check for Shopify's money format or use browser's locale
        if (Shopify && Shopify.currency && Shopify.currency.active) {
            // Some currencies use comma as decimal separator
            const commaDecimalCurrencies = ['EUR', 'DKK', 'NOK', 'SEK'];
            if (commaDecimalCurrencies.includes(currency) && newPrice.toString().includes('.')) {
                formattedPrice = newPrice.replace('.', ',');
            }
        } else {
            // Fallback to browser locale
            try {
                const numberFormat = new Intl.NumberFormat(navigator.language, {
                    style: 'decimal',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                formattedPrice = numberFormat.format(parseFloat(newPrice));
            } catch (e) {
                console.warn('Error formatting price with locale', e);
            }
        }

        return theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, formattedPrice);
    }
}

customElements.define('cut-calculator', CutCalculator);